import Customer from "./customer.model";
import Driver from "./driver.model";

export default class Vehicle {

    constructor(data) {
        this.id = null;
        this.timestamp = null;
        this.tagNumber = null;
        this.tagNumberClean = null;
        this.hu = null;
        this.huYear = null;
        this.huMonth = null;

        this.leasingNumber = null;
        this.fleetsNumber = null;

        this.mileage = null;
        this.aircon = null;
        this.airconLastMainteance = null;
        this.airconMaintenanceIntervall = null;

        this.inspectionLast = null;
        this.inspectionIntervallMonths = null;
        this.inspectionIntervallKm = null;
        this.firstAidKitExpiry = null;

        this.registration = null; // B
        this.chassisNumber = null; // E
        this.engineCode = null;
        this.manufacturerCode = null; // 2.1, HSN
        this.manufacturerName = null;
        this.modelName = null;
        this.typeCode = null; // 2.2, TSN
        this.typeName = null; // D.2
        this.versionCode = null; // 2.2, VSN
        this.versionName = null;
        this.typeAndVersionCode = null;
        this.fuelType = null; // 10
        this.capacity = null; // P.1
        this.kilowatt = null; // P.1
        this.horsepower = null;
        this.rpm = null; // P.4
        this.maxSpeed = null; // T
        this.length = null; // 18
        this.width = null; // 19
        this.height = null; // 20
        this.emptyWeight = null; // G
        this.color = null;
        this.colorCode = null;
        this.buildYearStart = null;
        this.buildYearEnd = null;

        this.customer = null;
        this.driver = null;

        if (data) {
            Object.assign(this, data);

            if (this.customer) {
                this.customer = new Customer(this.customer);
            }

            if (this.driver) {
                this.driver = new Driver(this.driver);
            }
        }
    }

    tagNumberUnformatted(){
        return Vehicle.tagNumberUnformatted(this.tagNumber);
    }

    static tagNumberUnformatted(tagNumber){
        return tagNumber ? tagNumber.replace(/\W/g, '') : null;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/vehicle.model.js